import script from "./ProjectList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectList.vue?vue&type=script&setup=true&lang=js"

import "./ProjectList.vue?vue&type=style&index=0&id=d877b830&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d877b830"]])

export default __exports__